<template>
  <img
    v-if="src"
    :src="src"
    :class="['gam-chessboard-piece', { 'is-flipped': isFlipped }]"
    draggable="false"
    :alt="piece"
  />
</template>

<script lang="ts" setup>
import { CHESS_PIECE_SVGS } from '@/views/composables/constants/components/gamChessboard.constants';
import { computed } from 'vue';

const props = defineProps<{
  piece: string;
  isFlipped?: boolean;
}>();

const src = computed(() => CHESS_PIECE_SVGS[props.piece] || '');
</script>

<style lang="scss" scoped>
.gam-chessboard-piece {
  width: 80%;
  height: 80%;
  object-fit: contain;
  pointer-events: none;
  user-select: none;
  -webkit-user-drag: none;
  transition: transform 0.15s ease;

  &.is-flipped {
    transform: rotate(180deg);
  }
}
</style>
